import React, { useEffect, useState } from "react";
import CalcBtn from "./CalcBtn";
import "./Calculator.css";
import { Row, Col } from "react-bootstrap";

import { Spinner } from "reactstrap";
import axios from "axios";
import SearchByStatus from "./SearchByStatus";
import CalcTable from "./CalcTable";
import { UserConsumer } from "../../../UserContext";
import { CalculatorAPIs } from "./CalculatorAPIs";
import { useHistory } from "react-router-dom";
import Header from "../../../components/Header";

const Calculator = (props) => {
	let token = null;
	let empJoinedOn,
		id = null;
	let currentYear = new Date().getFullYear();
	let flag = false;
	const history = useHistory();
	const [medicalFacility, setMedicalFacility] = useState({});
	const [internetFacility, setInternetFacility] = useState({});
	const [currSalary, setCurrSalary] = useState(0);
	const [selectedYear, setSelectedYear] = useState(null);
	const [defaultYear, setDefaultYear] = useState(new Date().getFullYear());
	const [total, setTotal] = useState({});
	const [medicalCalculations, setMedicalCalculations] = useState([]);
	const [calculation, setCalculation] = useState([]);
	const [remainingAmount, setRemainingAmount] = useState();
	const [internetbtnSubmitted, setInternetbtnSubmitted] = useState(false);
	const [fuelbtnSubmitted, setFuelBtnSubmitted] = useState(false);
	const [employeeId, setEmployeeId] = useState(
		props.location.state.employeeId ? props.location.state.employeeId : null
	);
	const [errorMessage, setErrorMessage] = useState("");
 
	const [years, setYears] = useState([]);
	const [activeButton, setActiveButton] = useState(false);
	const [internetButtonActive, setInternetButtonActive] = useState(false);
	const [fuelButtonActive, setFuelButtonActive] = useState(false);
	const [healthButtonActive, setHealthButtonActive] = useState(false);
	const [medicalCalculationLoading, setMedicalCalculationLoading] =
		useState(true);
	const [otherCalculationLoading, setOtherCalculationLoading] =
		useState(true);
	const [secondHalfRemainingAmount, setSecondHalfRemainingAmount] =
		useState(null);
	const recordID = props.location.state.recordID;
	const months = [
		{ label: "January", value: "1" },
		{ label: "February", value: "2" },
		{ label: "March", value: "3" },
		{ label: "April", value: "4" },
		{ label: "May", value: "5" },
		{ label: "June", value: "6" },
		{ label: "July", value: "7" },
		{ label: "August", value: "8" },
		{ label: "September", value: "9" },
		{ label: "October", value: "10" },
		{ label: "November", value: "11" },
		{ label: "December", value: "12" },
	  ];
	useEffect(() => {
		if (props.location.state.employeeId) {
			setEmployeeId(props.location.state.employeeId);
			medicalCalculation();
			
		} else {
			setEmployeeId(id);
			medicalCalculation();
		}
	}, []);
	const { remainingDental, remainingOPD, remainingParent } = medicalFacility;

	
	const medicalCalculation = () => {
		setActiveButton(true);
		setInternetButtonActive(false);
		setFuelButtonActive(false);
		setHealthButtonActive(false);
		setFuelBtnSubmitted(false);
		setCurrSalary(0);
		axios
			.get(
				`${
					CalculatorAPIs.GetMedicalCalculation
				}?EmployeeId=${employeeId}&Year=${
					selectedYear ? selectedYear : defaultYear
				}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				setMedicalCalculationLoading(false);
				setMedicalFacility(data);
				setMedicalCalculations(data["months"]);
				setTotal(data["total"]);
			});
		const list = [];
		do {
			list.unshift({ value: empJoinedOn, label: empJoinedOn.toString() });
			empJoinedOn++;
		} while (empJoinedOn != currentYear + 1);
		setYears(list);
	};
	const getByYear = (year, startMonth1, endMonth1, salary1, startMonth2, endMonth2, salary2, startMonth3, endMonth3, salary3) => {
	
		setMedicalCalculationLoading(true);
		setSelectedYear(year);
	  
		if (!internetbtnSubmitted && !fuelbtnSubmitted && !healthButtonActive) {
		  setMedicalCalculationLoading(true);
	  
		  const params = {
			Year: year,
			startMonth1:startMonth1,
			endMonth1:endMonth1,
			salary1:salary1||0,
			startMonth2:startMonth2,
			endMonth2:endMonth2,
			salary2:salary2||0,
			startMonth3:startMonth3,
			endMonth3:endMonth3,
			salary3:salary3,
			EmployeeId: employeeId,
			// Add other fields if needed
		  };
	  
		  axios.get(CalculatorAPIs.GetByYear, { params, headers: { Authorization: `Bearer ${token}` } })
			.then(({ data }) => {
			  setMedicalCalculationLoading(false);
			  setMedicalFacility(data);
			  setMedicalCalculations(data["months"]);
			  setTotal(data["total"]);
			});
		} else {
		  setOtherCalculationLoading(true);
	  	setMedicalCalculationLoading(true);
		  const params = {
			Year: year,
			EmployeeId: employeeId,
			// Add other fields if needed
		  };
	  
		  const calculationAPI =
			internetbtnSubmitted ? CalculatorAPIs.ByYearInternetCalculation :
			fuelbtnSubmitted ? CalculatorAPIs.GetFuelCalculation :
			CalculatorAPIs.GetHealthCalculation;
	  
		  axios.get(calculationAPI, { params, headers: { Authorization: `Bearer ${token}` } })
			.then(({ data }) => {
			  setOtherCalculationLoading(false);
			  setMedicalCalculationLoading(false);
			  setInternetFacility(data);
			  setCalculation(data["months"]);
			  setTotal(data["total"]);
			  setRemainingAmount(data.totalRemainingAmount);
			});
		}
	  };
	  
	const {
		limitAmount,
		claimedAmountOPD,
		claimedAmountParents,
		claimedDental,
		outStandingBalance,
	} = total;

	const internetCalculation = () => {
		setOtherCalculationLoading(true);
		setMedicalCalculationLoading(true);
		setActiveButton(false);
		setInternetButtonActive(true);
		setHealthButtonActive(false);
		setFuelButtonActive(false);
		setCurrSalary(null);
		setMedicalCalculations(null);
		setInternetbtnSubmitted(true);
		setFuelBtnSubmitted(false);
		axios
			.get(
				`${
					CalculatorAPIs.GetInternetCalculation
				}?EmployeeId=${employeeId}&Year=${
					selectedYear ? selectedYear : defaultYear
				}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				setOtherCalculationLoading(false);
				setMedicalCalculationLoading(false);
				setInternetFacility(data);
				setCalculation(data["months"]);
				setTotal(data["total"]);
				setRemainingAmount(data.totalRemainingAmount);
			});
	};
	const FuelCalculator = () => {
		setOtherCalculationLoading(true);
		
		setMedicalCalculationLoading(true);
		setActiveButton(false);
		setInternetButtonActive(false);
		setHealthButtonActive(false);
		setFuelButtonActive(true);
		setFuelBtnSubmitted(true);
		setCurrSalary(null);
		setMedicalCalculations(null);
		setInternetbtnSubmitted(false);
		setFuelBtnSubmitted(true);
		axios
			.get(
				`${
					CalculatorAPIs.GetFuelCalculation
				}?EmployeeId=${employeeId}&Year=${
					selectedYear ? selectedYear : defaultYear
				}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				setOtherCalculationLoading(false);
				
		setMedicalCalculationLoading(false);
				setInternetFacility(data);
				setCalculation(data["months"]);
				setTotal(data["total"]);
				setRemainingAmount(data.totalRemainingAmount);
			});
	};
	const healthClubCalculator = () => {
		setOtherCalculationLoading(true);
		
		setMedicalCalculationLoading(true);
		setActiveButton(false);
		setInternetButtonActive(false);
		setHealthButtonActive(true);
		setFuelButtonActive(false);
		setCurrSalary(null);
		setMedicalCalculations(null);
		setInternetbtnSubmitted(false);
		setFuelBtnSubmitted(false);
		axios
			.get(
				`${
					CalculatorAPIs.GetHealthCalculation
				}?EmployeeId=${employeeId}&Year=${
					selectedYear ? selectedYear : defaultYear
				}`,
				{ headers: { Authorization: `Bearer ${token}` } }
			)
			.then(({ data }) => {
				setOtherCalculationLoading(false);
				setMedicalCalculationLoading(false);
				setInternetFacility(data);
				setCalculation(data["months"]);
				setTotal(data["total"]);
				setRemainingAmount(data.totalRemainingAmount);
				setSecondHalfRemainingAmount(data.totalSecondHalf);
			});
	};
	return (
		<UserConsumer>
			{(userDetails) => {
				token = userDetails.token;
				id = userDetails.id;
				empJoinedOn = userDetails.empJoinedOn.split("-")[0];
				return (
					<div>
						<div className="calcBackwordIcon">
							<Header
								title="Calculator"
								navigateBack={() =>
									history.push(
										`/monthlyReimbursement/${recordID}`
									)
								}
							/>
						</div>
						{medicalCalculationLoading && (
              <div className="w-100 h-100 timesheetOverlay">
                <div className="align-items-center d-flex h-100 justify-content-center">
                  <Spinner color="secondary" />
                </div>
              </div>
            )}
            {(
              <>
						<Row className="d-flex align-items-center row-cols-2">
							<Col lg={12} md={12} sm={12} className="d-flex">
								<CalcBtn
									title={"Medical"}
									calculateAmount={medicalCalculation}
									className="Medical-btn"
									medicalCalculations={
										medicalCalculations
											? activeButton
											: false
									}
								/>
								<CalcBtn
									title={"Home Internet"}
									calculateAmount={internetCalculation}
									className="Home-Internet-btn"
									medicalCalculations={
										internetButtonActive
											? internetButtonActive
											: false
									}
								/>
								<CalcBtn
									title={"Fuel/Maintenance"}
									calculateAmount={FuelCalculator}
									className="Fuel-btn"
									medicalCalculations={
										fuelButtonActive
											? fuelButtonActive
											: false
									}
								/>
								{/* <CalcBtn
									title={"Health Club "}
									calculateAmount={healthClubCalculator}
									className="Medical-btn"
									medicalCalculations={
										healthButtonActive
											? healthButtonActive
											: false
									}
								/> */}
							</Col>
						</Row>
						{medicalCalculations && (
					<div className="excluded-hours mt-3 mb-0 pl-1">
					{errorMessage}
				  </div>
						)}
					<SearchByStatus
  yearOptions={years}
  monthOptions={months} // Pass the array of months as monthOptions
  medicalCalculations={medicalCalculations}
  getByYear={getByYear} 
  defaultYear={defaultYear}
  setErrorMessage={setErrorMessage} // Pass setErrorMessage function
  
/>

						<CalcTable
							calculations={calculation}
							medicalCalculations={medicalCalculations}
							medicalFacility={medicalFacility}
							internetFacility={internetFacility}
							flag={flag}
							remainingDental={remainingDental}
							remainingOPD={remainingOPD}
							remainingParent={remainingParent}
							limitAmount={limitAmount}
							claimedAmountOPD={claimedAmountOPD}
							claimedAmountParents={claimedAmountParents}
							claimedDental={claimedDental}
							outStandingBalance={outStandingBalance}
							medicalCalculationLoading={
								medicalCalculationLoading
							}
							otherCalculationLoading={otherCalculationLoading}
							totalRemainingAmount={
								internetFacility.totalRemainingAmount
							}
							internetButtonActive={internetButtonActive}
							healthButtonActive={healthButtonActive}
							fuelButtonActive={fuelButtonActive}
							claimedInternetAmount={
								internetButtonActive && internetFacility
									? internetFacility.total?.claimedAmount
									: null
							}
							claimedFuelAmount={
								fuelButtonActive && internetFacility
									? internetFacility.total?.claimedAmount
									: null
							}
							claimedHealthAmount={
								healthButtonActive && internetFacility
									? internetFacility.total?.claimedAmount
									: null
							}
							remainingAmount={remainingAmount}
							secondHalfRemainingAmount={
								healthButtonActive && internetFacility
									? internetFacility.totalSecondHalf
									: null
							}
						/>
						 </>
            )}
					</div>
				);
			}}
		</UserConsumer>
	);
};

export default Calculator;
